import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorCatchingInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMsg: string;

        if (error.error instanceof ErrorEvent) {
          // Client-side or network error
          errorMsg = `Client Error: ${error.error.message}`;
        } else {
          // Server-side error
          const backendMessage = this.extractBackendMessage(error);
          errorMsg = `Server Error: ${backendMessage}`;
        }

        console.error('HTTP Error Intercepted:', errorMsg);
        return throwError(errorMsg);
      })
    );
  }

  private extractBackendMessage(error: HttpErrorResponse): string {
    if (error.status === 0) {
      return error.statusText === 'Unknown Error'
        ? 'Unable to communicate with backend server'
        : 'Backend server is unreachable';
    }

    if (error.status === 500 && error.error?.message) {
      return error.error.message;
    }

    // Safe dynamic key access fallback
    const messageKey = Object.keys(error.error || {}).find(key =>
      key.toLowerCase().includes('message')
    );

    return messageKey
      ? error.error[messageKey]
      : typeof error.error === 'string'
        ? error.error
        : 'Unexpected server response';
  }
}
